import { ReactNode } from 'react';

import { Box } from '@simplywallst/ui-core';

import { StlyedPath } from './styled';

export const Segments = ({ children }: { children: ReactNode }) => {
  return (
    <Box position="absolute" top="0" width="100%">
      <svg width="100%" height="100%" viewBox="-20 -20 268 268">
        {children}
      </svg>
    </Box>
  );
};

interface Props {
  onClick?: () => void;
}

export const Value = ({ onClick }: Props) => (
  <StlyedPath
    onClick={onClick}
    data-cy-id="segment-value"
    fill="transparent"
    d="M46.9925 21.772C66.4691 7.62147 89.9255 1.11925e-05 114 0C138.074 -1.11925e-05 161.531 7.62143 181.007 21.772L114 114L46.9925 21.772Z"
  />
);

export const Future = ({ onClick }: Props) => (
  <StlyedPath
    onClick={onClick}
    data-cy-id="segment-future"
    fill="transparent"
    d="M181.008 21.7721C200.484 35.9227 214.981 55.8759 222.42 78.7721C229.86 101.668 229.86 126.332 222.42 149.228L114 114L181.008 21.7721Z"
  />
);

export const Past = ({ onClick }: Props) => (
  <StlyedPath
    onClick={onClick}
    data-cy-id="segment-past"
    fill="transparent"
    d="M222.42 149.228C214.981 172.124 200.484 192.077 181.008 206.228C161.531 220.379 138.074 228 114 228L114 114L222.42 149.228Z"
  />
);

export const Health = ({ onClick }: Props) => (
  <StlyedPath
    onClick={onClick}
    data-cy-id="segment-health"
    fill="transparent"
    d="M114 228C89.9256 228 66.4691 220.379 46.9925 206.228C27.5158 192.077 13.019 172.124 5.57955 149.228L114 114L114 228Z"
  />
);

export const Dividend = ({ onClick }: Props) => (
  <StlyedPath
    onClick={onClick}
    data-cy-id="segment-dividend"
    fill="transparent"
    d="M5.57956 149.228C-1.85985 126.332 -1.85985 101.668 5.57956 78.7721C13.019 55.8759 27.5159 35.9226 46.9925 21.772L114 114L5.57956 149.228Z"
  />
);
